import { Link } from "react-router-dom";
import { Check, UserCheck } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

const FIELDS = [["picture", "Profilbild"], ["cover", "Titelbild"], ["bio", "Über mich"], ["location", "Wohnort"], ["birthday", "Geburtstag"]];

export function ProfileProgress({ hideWhenDone = false, linkToEdit = false }) {
  const { user } = useAuth();
  if (!user) return null;
  const done = FIELDS.filter(([k]) => user[k]).length;
  if (hideWhenDone && done === FIELDS.length) return null;
  const missing = FIELDS.filter(([k]) => !user[k]).map(([, l]) => l);
  return (
    <div className="bg-white rounded-3xl p-5 border border-pink-100 space-y-3" data-testid="profile-progress">
      <div className="flex items-center gap-2">
        <UserCheck className="w-5 h-5 text-rose-500" />
        <p className="font-bold flex-1">Profil {done === FIELDS.length ? "vollständig 🎉" : "vervollständigen"}</p>
        <span className="text-sm font-extrabold text-rose-600" data-testid="profile-progress-count">{done} von {FIELDS.length} erledigt</span>
      </div>
      <div className="h-2.5 rounded-full bg-rose-50 overflow-hidden"><div className="h-full pink-gradient rounded-full transition-[width] duration-700" style={{ width: `${(done / FIELDS.length) * 100}%` }} /></div>
      <ul className="flex flex-wrap gap-2">
        {FIELDS.map(([k, l]) => (
          <li key={k} data-testid={`profile-progress-${k}`} className={`inline-flex items-center gap-1 px-2.5 h-7 rounded-full text-xs font-semibold ${user[k] ? "bg-emerald-50 text-emerald-700" : "bg-slate-100 text-slate-500"}`}>
            {user[k] && <Check className="w-3 h-3" />} {l}
          </li>
        ))}
      </ul>
      {missing.length > 0 && (
        <p className="text-xs text-slate-500" data-testid="profile-progress-hint">
          Es fehlt noch: <b>{missing.join(", ")}</b>. Ein vollständiges Profil zählt einmalig als Tagesmission.
          {linkToEdit && <> <Link to="/profil" data-testid="profile-progress-edit" className="font-semibold text-rose-600 hover:underline">Jetzt ergänzen →</Link></>}
        </p>
      )}
    </div>
  );
}
